import { useApi } from './apiService';

export const useRemediationPlanService = () => {
  const api = useApi();

  /**
   * Update remediation plan status for a tenant
   * @param tenantId - selected tenant ID
   * @param planId - remediation plan ID
   * @param targetStatus - new status: "Approved" | "ApprovalRejected"
   * @param currentStatus - expected current status in backend for valid transition
   * @returns response data
   */
  const updateRemediationPlanStatus = async (
    tenantId: string,
    planId: string,
    targetStatus: 'Approved' | 'ApprovalRejected',
    currentStatus: 'Created' | 'SubmittedForApproval' = 'Created',
  ) => {
    try {
      const payload = {
        CurrentStatusCode: currentStatus,
        TargetStatusCode: targetStatus,
      };

      const response = await api.put(
        `patchcenterservice/remediationplan/${tenantId}/manage-remediation-plan-status/${planId}`,
        JSON.stringify(payload),
        {
          headers: { 'Content-Type': 'application/json' },
        },
      );

      return response.data;
    } catch (error) {
      console.error('Error updating remediation plan status:', error);
      throw error;
    }
  };

  return { updateRemediationPlanStatus };
};
